module.exports = __webpack_public_path__ + "img/Fehlertyp5_Dok1.a291e168.jpg";